/**
 *   Created by FANGlh on 2019/1/19 12:32.
 *   Desc:
 */

import React,{Component} from 'react';
import {Link} from 'react-router-dom';
import './PhoneInfoItem.css';
import { connect } from 'react-redux';
import {Input, Button} from 'antd';
import { Modal, Toast } from 'antd-mobile';
import { API } from '../../configs/api.config';
import { fetchGet, fetchPost } from '../../utils/fetchRequest';

const { alert } = Modal

export default class PhoneInfoItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: this.props.itemdata,
            methods: '',
        }
    }

    render() {
        const {item} = this.state;
        return (
            <div style={{padding:10}}>
                <div style={{backgroundColor:'#FFF',width:'100%',padding:10,borderRadius:10}}>
                    <div className="leave_row_sty">
                        <div style={{fontSize: 16, color: "#000000",width:'60%',textAlign:'left'}}> 家长：{item.name}</div>
                        <div style={{width:'40%',textAlign:'right'}}>

                        </div>
                    </div>
                    <div className="leave_row_sty" style={{marginTop:5}}>
                        <div  style={{fontSize: 14, color: "#999999",width:'25%'}}>学生姓名：</div>
                        <div style={{fontSize: 14, color: "#666666",width:'75%'}}>{item.stuName}</div>
                    </div>

                    <div className="leave_row_sty" style={{marginTop:5}}>
                        <div  style={{fontSize: 14, color: "#999999",width:'25%'}}>家长电话：</div>
                        <div style={{fontSize: 14, color: "#666666",width:'75%'}}>{item.phone}</div>
                    </div>

                    <div className="leave_row_sty" style={{marginTop:5}}>
                        <div style={{fontSize: 14, color: "#999999",width:'20%'}}>关系：</div>
                        <div style={{fontSize: 14, color: "#666666",width:'40%',wordWrap:'break-word'}}>{item.relation}</div>
                        <div style={{width:'40%',textAlign:'right'}}>
                            {
                                item.phone == item.userPhone ?
                                    <span style={{fontSize: 12, color: "##686868"}}>正常</span>
                                    :
                                    <span style={{fontSize: 12, color: "#FA5200"}} onClick={() => { this.wxPhone('delete',item.id,item.stuId)}}>删除</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    wxPhone = (methods,id,stuId) => {
        this.state.methods = methods
        let err = ''
        let parentId = ''
        const { userInfo } = this.props

        if (id == null) {
            return;
        }
        if(methods=='update'){
            Toast.loading('')
            fetchPost(API.PAY_ACTION1, {
                methods: methods,
                parentId: id,
                stuId: stuId
            }).then((response) => {
                Toast.hide()
                const data = response.data

            }).catch((error) => {
                console.log('error:' + JSON.stringify(error))
                /*const timer = setTimeout(()=>{
                    Toast.hide();
                    clearTimeout(timer);
                }, 8000);*/
            })
        } else {
            alert('', '确认删除当前号码吗？删除后将取消绑定', [
                {
                    text: '取消', onPress: () => {},
                },
                {
                    text: '确定', onPress: () => {
                        Toast.loading('')
                        fetchPost(API.PARENT_PHONE_DELETE, {
                            methods: methods,
                            parentId: id,
                            stuId: stuId
                        }).then((response) => {
                            Toast.hide()
                            console.log('response:' + JSON.stringify(response))
                            if (response.success) {
                                Toast.show(response.data)
                            } else {
                                Toast.fail(response.message, 2)
                            }
                        }).catch((error) => {
                            Toast.hide()
                            console.log('error:' + JSON.stringify(error))
                        })
                    },
                },
            ])
        }
    }

}
